<mobi-media-layout
  [id]="paragraph().anchorLinkUrl ? paragraph().anchorLinkUrl : paragraph().id"
  [media]="media"
  [title]="paragraph().title"
  [text]="paragraph().text"
  [width]="paragraph().width"
  [position]="paragraph().position"
  [titleSize]="paragraph().titleSize"
  [mobiTracking]="paragraph()"
>
  <ng-template #media>
    @if (paragraph().video) {
      <mobi-media class="block" [entity]="paragraph().video" />
    }
    @if (paragraph().video && paragraph().video.description) {
      <mobi-text
        class="pt-[10px] mobi-ui-font-italic block"
        [data]="paragraph().video.description ?? ''"
      />
    }
    @if (paragraph().simplex) {
      <mobi-media
        class="block"
        [entity]="{
          type: 'MediaRemoteVideo',
          embedUrl: paragraph().simplex,
          uuid: 'simplex-' + paragraph().uuid,
        }"
      />
    }
  </ng-template>
</mobi-media-layout>
